import { IInventoryRepository } from 'domain/repositories/Inventory'

export const fetchInventories = (repo: IInventoryRepository) => async () => {
  const list = await repo.fetchAll()
  return list
}
